import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const SpaceNavigationContent: LoadableType<{
	navigationProps: any;
	errorProps: any;
	spaceDetails: any;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceNavigationContent" */ './SpaceNavigationContent.tsx'
			)
		).SpaceNavigationContent,
});
